import script from "./MyApp.vue?vue&type=script&setup=true&lang=js"
export * from "./MyApp.vue?vue&type=script&setup=true&lang=js"

import "./MyApp.vue?vue&type=style&index=0&id=8b26fcb0&lang=css"

const __exports__ = script;

export default __exports__